import { MatTableDataSource } from '@angular/material';
import { StatisticService } from '../../../shared/services/statistic.service';
import * as moment from 'moment';
import { InfoPopupComponent } from '../info-popup/info-popup.component';
import { UserService } from '../../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
var RankingComponent = (function () {
    function RankingComponent(stats, userService) {
        this.stats = stats;
        this.userService = userService;
        this.displayedColumns = ['position', 'name', 'punkte'];
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.aliasForm = new FormGroup({
            alias: new FormControl('', [Validators.maxLength(30)]),
        });
        this.date = moment();
        this.loadLeaderboard();
    }
    RankingComponent.prototype.ngAfterViewInit = function () {
        // scroll to current user
        // setTimeout(() => {
        //   document.querySelector('mat-table .selected').scrollTop(false);
        // }, 1000);
        var _this = this;
        this.userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            var alias = user.alias;
            if (!alias) {
                _this.aliasPopup.show();
            }
        });
    };
    RankingComponent.prototype.loadLeaderboard = function (month, year) {
        var _this = this;
        this.stats.getCompanyLeaderboard(month, year).then(function (data) {
            // order from highest to lowest points
            data.sort(function (a, b) {
                return b.points - a.points;
            });
            for (var index = 0; index < data.length; index++) {
                data[index].position = index + 1;
            }
            _this.dataSource = new MatTableDataSource(data);
        });
    };
    RankingComponent.prototype.nextMonth = function () {
        this.date.add(1, 'M');
        this.loadLeaderboard(this.date.month() + 1, this.date.year());
    };
    RankingComponent.prototype.prevMonth = function () {
        this.date.subtract(1, 'M');
        this.loadLeaderboard(this.date.month() + 1, this.date.year());
    };
    RankingComponent.prototype.saveAlias = function (anonym) {
        var _this = this;
        if (!anonym && !this.aliasForm.valid) {
            return;
        }
        var alias = anonym ? 'anonym' : this.aliasForm.value.alias ? this.aliasForm.value.alias : 'anonym';
        this.userService
            .updateUser({
            alias: alias,
        })
            .then(function () { return _this.userService.getThisUser(); });
        this.dataSource.data.find(function (item) { return item.isRequester === true; }).alias = alias;
        this.aliasPopup.close();
    };
    return RankingComponent;
}());
export { RankingComponent };
var ELEMENT_DATA = [
    { position: 0, alias: '...', points: 0, isRequester: false },
    { position: 1, alias: '...', points: 0, isRequester: false },
    { position: 2, alias: '...', points: 0, isRequester: false },
    { position: 3, alias: '...', points: 0, isRequester: false },
    { position: 4, alias: '...', points: 0, isRequester: false },
    { position: 5, alias: '...', points: 0, isRequester: false },
];



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/ranking/ranking.component.ts.pre-build-optimizer.js